import { Container, Suport } from "./styles.js";

import ReplacePassView from "../../views/ReplacePass/index.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
function ReplacePass() {
  return (
    <Container>
      <ReplacePassView />
       <Suport href="https://wa.me/5547991153595" target="_blank">
                    <u>Suporte</u>
                    <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
                  </Suport>
    </Container>
  );
}

export default ReplacePass;
